import { render, staticRenderFns } from "./ProductCategoryTemplate.vue?vue&type=template&id=31a180c4&scoped=true&"
import script from "./ProductCategoryTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTemplate.vue?vue&type=style&index=0&id=31a180c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a180c4",
  null
  
)

export default component.exports